// extracted by mini-css-extract-plugin
export default {"root":"ikWy88aW","icon":"mfxmmvfc","title":"v98tFGFn","url":"HLBqYJUm","open":"i8b7hWkL","copy":"FEf0o1yO"};